


































































import Vue from 'vue';
import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import * as Constants from '@/constants.ts';
import { format } from 'date-fns';

enum eOrderTimeMode {
  rightNow,
  future,
}

enum eDays {
  today,
  tomorrow,
}

const minutesInADay = 1440;
const msInAMinute = 60000;

export default Vue.extend({
  data() {
    return {
      timesArrayForToday: [],
      timesArrayForTomorrow: [],
      dayArray: [],
      currentDay: eDays.today,
      currentSelectedTimeAsMsSinceEpoch: this.$store.state.requestTime,
      eOrderTimeMode,
      eDays,
      orderTimeMode: eOrderTimeMode.rightNow,
      allRoutes: Constants.allRoutes,
      finishedInitialization: false,
    };
  },
  mounted() {
    this.reload();
  },
  computed: {
    cannotOrder(): boolean {
      return this.$store.getters.cannotOrder;
    },
    cannotOrderMessage(): string {
      return Util.t?.theLocationIsClosedAndNotOpenSoon.supplant([Util.t[this.$store.state.appMode].toLowerCase()]);
    },
    isOpen() {
      switch (this.$store.state.appMode) {
        case Enums.eAppModes.takeout:
          return this.$store.state.takeoutAvailable;
          break;
        case Enums.eAppModes.delivery:
          return this.$store.state.deliveryAvailable;
          break;
        case Enums.eAppModes.tableside:
          return this.$store.state.tablesideAvailable;
          break;
      }
    },
    requestedTime() {
      return this.$store.state.requestedTime;
    },
    appMode(): Enums.eAppModes {
      return this.$store.state.appMode;
    },
    currentLocation(): EstablishmentLocation {
      return this.$store.state.currentLocation;
    },
    orderAheadEnabled(): boolean {
      return this.$store.state.currentLocation.orderAheadEnabled && !this.isTablesideMode;
    },
    isTablesideMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.tableside;
    },
  },
  watch: {
    appMode() {
      this.reload();
    },
    currentLocation() {
      this.reload();
    },
    currentSelectedTimeAsMsSinceEpoch(currentSelectedTimeAsMsSinceEpoch: number) {
      if (currentSelectedTimeAsMsSinceEpoch && currentSelectedTimeAsMsSinceEpoch < Date.now()) {
        Vue.nextTick(() => {
          this.setNextAvailableTime();
        });
        return;
      }
      this.$store.commit('setRequestedTime', this.$data.currentSelectedTimeAsMsSinceEpoch);
    },
    currentDay() {
      const outOfRangeCheckForTomorrow = this.$data.currentDay === eDays.tomorrow && this.requestedTime < this.startOfTomorrowAsEpochTimeInMs();
      const outOfRangeCheckForToday = this.$data.currentDay === eDays.today && this.requestedTime > this.startOfTodayAsEpochTimeInMs();
      const requestedTimeOutOfRangeForSelectedDay = outOfRangeCheckForTomorrow || outOfRangeCheckForToday;
      Vue.nextTick(() => {
        if (!this.requestedTime || requestedTimeOutOfRangeForSelectedDay) {
          this.setNextAvailableTime();
        }
      });
    },
    $route(to, from) {
      if (to.path.includes('/order')) {
        this.reload();
      }
    },
  },
  methods: {
    routerPush(args: any) {
      Util.routerPush(args);
    },
    goToCodeEntry() {
      Util.rootComponent.showCodeEntryPageFunc();
    },
    startOfTomorrowAsEpochTimeInMs() {
      return this.startOfTodayAsEpochTimeInMs() + minutesInADay * msInAMinute;
    },
    reload() {
      if (!this.currentLocation.docId || !this.orderAheadEnabled) {
        return;
      }
      this.$data.cannotOrderMessage = '';
      const dayArray = [];
      const minutesArray: number[] = [0, 15, 30, 45];
      const periodArray: string[] = ['am', 'pm'];
      const timesArrayForToday: any[] = [];
      const timesArray: any[] = [];
      const timesArrayForTomorrow: any[] = [];
      const currDate = new Date();
      const currTimeOfDayInMinutes: number = currDate.getHours() * 60 + currDate.getMinutes();

      for (let hour = 0; hour < 24; hour++) {
        minutesArray.forEach((min: number) => {
          const epochDateInMs = this.startOfTodayAsEpochTimeInMs() + (hour * 60 + min) * msInAMinute; // Time of day in minutes
          const period = hour < 12 ? 'AM' : 'PM';
          if (currTimeOfDayInMinutes < epochDateInMs && this.isValidTime(epochDateInMs)) {
            timesArrayForToday.push({
              text: `${hour % 12 || '12'}:${min || '00'} ${period}`,
              value: epochDateInMs,
            });
          }
        });
      }

      for (let hour = 0; hour < 24; hour++) {
        minutesArray.forEach((min: number) => {
          const epochDateInMs = this.startOfTomorrowAsEpochTimeInMs() + (hour * 60 + min) * msInAMinute; // Time of day in minutes
          const period = hour < 12 ? 'AM' : 'PM';
          if (currTimeOfDayInMinutes < epochDateInMs && this.isValidTime(epochDateInMs)) {
            timesArrayForTomorrow.push({
              text: `${hour % 12 || '12'}:${min || '00'} ${period}`,
              value: epochDateInMs,
            });
          }
        });
      }

      if (timesArrayForToday.length) {
        dayArray.push({ text: Util.t?.today, value: eDays.today });
      }

      if (timesArrayForTomorrow.length) {
        dayArray.push({ text: Util.t?.tomorrow, value: eDays.tomorrow });
      }

      this.$data.finishedInitialization = true;
      this.$data.timesArrayForToday = timesArrayForToday;
      this.$data.timesArrayForTomorrow = timesArrayForTomorrow;
      this.$data.dayArray = dayArray;

      if (!this.requestedTime) {
        // In this case request time selection has yet to be made
        Vue.nextTick(() => {
          if (this.isOpen) {
            this.setOrderTimeMode(eOrderTimeMode.rightNow);
          } else {
            this.setOrderTimeMode(eOrderTimeMode.future);
          }
        });
      } else {
        // In this case a request time selection was made before somewhere.
        this.$data.currentSelectedTimeAsMsSinceEpoch = this.requestedTime;
        this.$data.orderTimeMode = eOrderTimeMode.future;
        if (this.requestedTime > this.startOfTomorrowAsEpochTimeInMs()) {
          this.$data.currentDay = eDays.tomorrow;
        }
        this.$forceUpdate();
      }
    },
    setNextAvailableTime() {
      if (!this.$data.finishedInitialization || this.$store.state.appMode === null) {
        return;
      }
      if (this.$data.currentDay === eDays.today && this.$data.timesArrayForToday.length) {
        this.$data.currentSelectedTimeAsMsSinceEpoch = this.$data.timesArrayForToday[0]?.value;
      } else {
        this.$data.currentDay = eDays.tomorrow;

        this.$data.currentSelectedTimeAsMsSinceEpoch = this.$data.timesArrayForTomorrow[0]?.value;
      }
      this.$forceUpdate();
    },
    setOrderTimeMode(orderTimeMode: number) {
      this.$data.orderTimeMode = orderTimeMode;
      if (orderTimeMode === eOrderTimeMode.rightNow) {
        this.$data.currentSelectedTimeAsMsSinceEpoch = 0;
      } else {
        // If ordering for the future start with the next available time.
        this.setNextAvailableTime();
      }
    },
    startOfTodayAsEpochTimeInMs() {
      const startOfDay = new Date();
      startOfDay.setHours(0, 0, 0, 0);
      return Math.round(startOfDay.getTime());
    },
    isValidTime(epochDateInMs: number): boolean {
      if (Date.now() > epochDateInMs) {
        return false;
      }
      if (this.$store.state.appMode === Enums.eAppModes.takeout && this.currentLocation.takeoutTimeSlots) {
        return Util.isRightTime(this.currentLocation.takeoutTimeSlots, this.currentLocation.utcOffset, epochDateInMs);
      } else if (this.$store.state.appMode === Enums.eAppModes.delivery && this.currentLocation.deliveryTimeSlots) {
        return Util.isRightTime(this.currentLocation.deliveryTimeSlots, this.currentLocation.utcOffset, epochDateInMs);
      }
      return false;
    },
  },
});
